module.exports = __webpack_public_path__ + "static/media/bat3.ab14890f.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/battery/bat3.png
// module id = 471
// module chunks = 0